<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 24 24" fill="none">
    <path
      d="M20.125 12C20.125 16.4883 16.4883 20.125 12 20.125C7.51172 20.125 3.875 16.4883 3.875 12C3.875 7.51172 7.51172 3.875 12 3.875C16.4883 3.875 20.125 7.51172 20.125 12ZM2 12C2 17.5234 6.47656 22 12 22C17.5234 22 22 17.5234 22 12C22 6.47656 17.5234 2 12 2C6.47656 2 2 6.47656 2 12ZM11.0625 6.6875V12C11.0625 12.3125 11.2188 12.6055 11.4805 12.7812L15.2305 15.2812C15.6602 15.5703 16.2422 15.4531 16.5312 15.0195C16.8203 14.5859 16.7031 14.0078 16.2695 13.7188L12.9375 11.5V6.6875C12.9375 6.16797 12.5195 5.75 12 5.75C11.4805 5.75 11.0625 6.16797 11.0625 6.6875Z"
      :fill="color"
    />
  </svg>
</template>

<script>
export default {
  name: 'LengthIcon',
  props: {
    size: {
      type: Number,
      default: 16
    },
    color: {
      type: String,
      default: '#484848'
    }
  }
};
</script>
